export default function HomeFAQ() {
  const faqs = [
    {
      q: '迷妹漫画上的所有漫画都是免费的吗？',
      a: '是的！迷妹漫画平台上的所有漫画资源均为免费提供，无需任何付费即可畅享全本完结与连载漫画，真正做到零花费免费看漫画。我们致力于为广大漫画爱好者打造一个开放、免费的漫画阅读乐园。',
    },
    {
      q: '迷妹漫画支持哪些阅读方式？',
      a: '迷妹漫画支持下拉式滚动阅读，采用竖屏漫画布局设计，完美适配手机和电脑端阅读体验。用户只需向下滑动即可连续阅读漫画内容，无需翻页操作，阅读体验流畅自然。',
    },
    {
      q: '迷妹漫画有哪些类型的漫画资源？',
      a: '迷妹漫画拥有海量免费漫画资源库，全面覆盖日漫、韩漫、国漫等热门类型，包括少年热血、少女恋爱、搞笑日常、奇幻冒险、悬疑恐怖、科幻未来、治愈日常、动作格斗、异世界等多个分类，满足不同漫画迷的阅读偏好。',
    },
    {
      q: '迷妹漫画的漫画更新频率是怎样的？',
      a: '迷妹漫画平台上的连载漫画保持与官方同步更新的节奏，确保漫画迷能够第一时间看到最新章节。完结漫画则提供全本免费阅读服务，不限章节不限次数。',
    },
    {
      q: '如何在迷妹漫画上找到想看的漫画？',
      a: '您可以通过迷妹漫画顶部的搜索框输入漫画名称进行检索，也可以通过首页的分类导航按类型浏览，或在热门推荐和排行榜中发现大家都在追的高人气漫画作品。',
    },
  ];

  return (
    <section className="bg-background-100 py-10 md:py-14">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>常见问题</h2>
          <p className="text-sm text-foreground-500 mt-1">关于迷妹漫画，你可能想知道</p>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <details key={idx} className="group bg-white rounded-xl border border-background-200/50 overflow-hidden">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-50 transition-colors list-none">
                <span className="text-sm font-medium text-foreground-800 pr-4">{faq.q}</span>
                <i className="ri-arrow-down-s-line w-5 h-5 flex items-center justify-center text-foreground-400 group-open:rotate-180 transition-transform flex-shrink-0"></i>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": faqs.map(faq => ({
              "@type": "Question",
              "name": faq.q,
              "acceptedAnswer": {
                "@type": "Answer",
                "text": faq.a,
              },
            })),
          }),
        }}
      />
    </section>
  );
}